import toggle from 'components/common/hoc/toggle'
import CheckboxDescription from './CheckboxDescription'

export default toggle(CheckboxDescription)
